import Vue from 'vue';
import Vuex from 'vuex';
import jQuery from 'jquery';

Vue.use(Vuex);

export default new Vuex.Store(
    {
        state: {
            // api_url_base: '',
            loader: false,
            resorts: [],
            results: {},
            selections: {
                resort: '',
                type: '',
                view: '',
                start: null,
                end: null
            }
        },
        mutations: {
            set_value: function( state, payload ) {
                if ( payload ) {
                    if ( payload.collection ) {
                        Vue.set( state[ payload.collection ], payload.attribute, payload.data );
                    } else {
                        Vue.set( state, payload.attribute, payload.data );
                    }
                }
            }
        },
        actions: {
            initialize: function( context ) {
                context.dispatch( 'get_resorts' );
            },

            get_resorts: function( context ) {
                context.commit( 'set_value', { attribute: 'loader', data: true } );

                jQuery.ajax(
                    // this.state.api_url_base + '/wp-admin/admin-ajax.php?action=dvca_pc_get_resorts',
                    window.DVCA_PARAMS['CMSREST'] + '/wp-admin/admin-ajax.php?action=dvca_pc_get_resorts',
                    {
                        dataType: 'json',
                        method: 'GET',
                        success: function( response ) {
                            if ( ( response ) && ( response.resorts ) ) {
                                context.commit( 'set_value', { attribute: 'resorts', data: response.resorts } );

                                /*
                                response.resorts.sort( function( left, right ) {
                                    return ( ( left.title > right.title ) ? 1 : -1 );
                                } );
                                 */
                            } else {
                                alert( 'We apologize, but an error has occurred when initializing. Please try again, or let us know about this error if it persists.' );
                            }

                            context.commit( 'set_value', { attribute: 'loader', data: false } );
                        }
                    }
                );
            },

            calculate: function( context ) {
                context.commit( 'set_value', { attribute: 'loader', data: true } );

                jQuery.ajax(
                    // this.state.api_url_base + '/wp-admin/admin-ajax.php?action=dvca_pc_calculate_points',
                    window.DVCA_PARAMS['CMSREST'] + '/wp-admin/admin-ajax.php?action=dvca_pc_calculate_points',
                    {
                        dataType: 'json',
                        method: 'POST',
                        data: this.state.selections,
                        success: function( response ) {
                            if ( ( response ) && ( response.total >= 0 ) && ( response.schedule ) ) {
                                console.log( response );

                                context.commit( 'set_value', { attribute: 'results', data: response } );
                            } else {
                                alert( 'We apologize, but a point calculation could not be completed at this time.  Please try again later.' );
                            }

                            context.commit( 'set_value', { attribute: 'loader', data: false } );
                        }
                    }
                );
            }
        },
        modules: {},
    }
);
